import axios from "axios";
import { getBaseUrl } from "./urls";
import { RESET_GLOBAL_COUNTRY } from "./globalAction";
export const FETCH_TOPIC_PERFORMANCE_DATA = 'FETCH_TOPIC_PERFORMANCE_DATA';
export const FETCH_TOPIC_OVERVIEW_DATA = 'FETCH_TOPIC_OVERVIEW_DATA';
export const FETCH_TOPIC_OVERVIEW_DATA_2 = 'FETCH_TOPIC_OVERVIEW_DATA_2';
export const FETCH_SOURCES_SOV_DATA = 'FETCH_SOURCES_SOV_DATA';
export const TOGGLE_POST_IN_FOCUS_MODAL = 'TOGGLE_POST_IN_FOCUS_MODAL';
export const FETCH_POST_COMMENTS = 'FETCH_POST_COMMENTS';
export const FETCH_POST_COMMENTS_COUNT = 'FETCH_POST_COMMENTS_COUNT';
export const SWITCH_TOPICS = 'SWITCH_TOPICS';
export const FETCH_THEMES_SOV_DATA = 'FETCH_THEMES_SOV_DATA';
export const FETCH_OVERALL_SENTIMENT_DATA = 'FETCH_OVERALL_SENTIMENT_DATA';
export const FETCH_SENTIMENT_TRENDS_DATA = 'FETCH_SENTIMENT_TRENDS_DATA';
export const FETCH_TOP_POSTS_DATA = 'FETCH_TOP_POSTS_DATA';
export const CHANGE_VIEW_TYPE = 'CHANGE_VIEW_TYPE';
export const FETCH_OVERALL_SOV_2_DATA = 'FETCH_OVERALL_SOV_2_DATA';
export const FETCH_OVERALL_SOV_2_DATA_DAYWISE = 'FETCH_OVERALL_SOV_2_DATA_DAYWISE';
export const FETCH_OVERALL_SOV_3_DATA = 'FETCH_OVERALL_SOV_3_DATA';
export const FETCH_OVERALL_SOV_3_DATA_DAYWISE = 'FETCH_OVERALL_SOV_3_DATA_DAYWISE';
export const FETCH_OVERALL_SOV_DATA = 'FETCH_OVERALL_SOV_DATA';
export const FETCH_OVERALL_SOV_DATA_DAYWISE = 'FETCH_OVERALL_SOV_DATA_DAYWISE';
export const FETCH_SENTIMENT_VERTBATIMS_DATA = 'FETCH_SENTIMENT_VERTBATIMS_DATA';
export const RESET_WIDGETS_DATA = 'RESET_WIDGETS_DATA';
export const FETCH_PLATFORM_BREAK_DATA = 'FETCH_PLATFORM_BREAK_DATA';
export const TOPIC_OVERVIEW_COMPARISON_SWITCHER = 'TOPIC_OVERVIEW_COMPARISON_SWITCHER';
export const SWITCH_TO_COMPARISON= 'SWITCH_TO_COMPARISON';
export const FETCH_TOPIC_COMPARISON_DATA = 'FETCH_TOPIC_COMPARISON_DATA';
export const SET_TOPIC_COMPARISON_FILTERS = 'SET_TOPIC_COMPARISON_FILTERS';

export const fetchTopicPerformanceData = (params) => {
    let token = localStorage.getItem("token");
    let req = axios
        .post(`${getBaseUrl()}/sk2/cc/widgets/v3/topic-performance?access-token=${token}`, params)
        .then(response => {
            return response;
        })
        .catch(err => {
            console.log(err);
            return err;
        });

    return {
        type: FETCH_TOPIC_PERFORMANCE_DATA,
        payload: req
    }
}

export const fetchTopicOverviewData = (params) => {
    let token = localStorage.getItem("token");
    let req = axios
        .post(`${getBaseUrl()}/sk2/cc/widgets/topic-overview?access-token=${token}`, params)
        .then(response => {
            return response;
        })
        .catch(err => {
            console.log(err);
            return err;
        });

    return {
        type: FETCH_TOPIC_OVERVIEW_DATA,
        payload: req
    }
}

export const fetchTopicOverviewData_2 = (params) => {
    let token = localStorage.getItem("token");
    let req = axios
        .post(`${getBaseUrl()}/sk2/cc/widgets/topic-overview?access-token=${token}`, params)
        .then(response => {
            return response;
        })
        .catch(err => {
            console.log(err);
        });

    return {
        type: FETCH_TOPIC_OVERVIEW_DATA_2,
        payload: req
    }
}

export const fetchSourcesSOVData = (params) => {
    let token = localStorage.getItem("token");
    let req = axios
        .post(`${getBaseUrl()}/sk2/cc/widgets/sources-sov-by-enagagement?access-token=${token}`, params)
        .then(response => {
            return response;
        })
        .catch(err => {
            console.log(err);
            return err;
        });

    return {
        type: FETCH_SOURCES_SOV_DATA,
        payload: req
    }
}

export const togglePostInFocusModal = ( post = null ) => {
    return {
        type: TOGGLE_POST_IN_FOCUS_MODAL,
        payload: post
    }
}

export const changeViewType = (viewType) => {
    return {
        type: CHANGE_VIEW_TYPE,
        payload: viewType
    }
}

export const getPostComments = filters => {
    let token = localStorage.getItem("token");
    filters += "&offset=1";
    filters += "&data=1";
    filters += "&access-token=" + token;
    filters += "&recordsPerPage=1000";
    filters += "&post_type=1";

    let res = axios
        .post(`${getBaseUrl()}/search`, filters, {
            cache: false,
            headers: {
                "Content-Type": "application/x-www-form-urlencoded; charset=UTF-8"
            }
        })
        .then(res => res.data);
    return {
        type: FETCH_POST_COMMENTS,
        payload: res
    };
}

export const getPostCommentsCount = filters => {
    let token = localStorage.getItem("token");
    filters += "&offset=1";
    filters += "&data=1";
    filters += "&access-token=" + token;
    filters += "&recordsPerPage=1000";
    filters += "&post_type=1";

    let res = axios
        .post(`${getBaseUrl()}/search`, filters, {
            cache: false,
            headers: {
                "Content-Type": "application/x-www-form-urlencoded; charset=UTF-8"
            }
        })
        .then(res => res.data);
    return {
        type: FETCH_POST_COMMENTS_COUNT,
        payload: res
    };
}

// Get Volume of Conversation
export const getVolumeOfConversation = (params) => {
	let token = localStorage.getItem("token");
    params += '&access-token=' + token;
    
	let req = axios.post(`${getBaseUrl()}/sk2/cc/widgets/v2/share-of-voice`, params, {
		cache: false,
		headers: {
			"Content-Type":
				"application/x-www-form-urlencoded; charset=UTF-8"
		}
	}).then(res => res.data).catch(err => err)

	return {
        type: FETCH_OVERALL_SOV_DATA,
        payload: req
    };
}

// Get Volume of Conversation
export const getVolumeOfConversation2 = (params) => {
	let token = localStorage.getItem("token");
    params += '&access-token=' + token;
	let req = axios.post(`${getBaseUrl()}/sk2/cc/widgets/v2/share-of-voice`, params, {
		cache: false,
		headers: {
			"Content-Type":
				"application/x-www-form-urlencoded; charset=UTF-8"
		}
	}).then(res => res.data)

	return {
        type: FETCH_OVERALL_SOV_2_DATA,
        payload: req
    };
}

// Get Volume of Conversation
export const getVolumeOfConversation3 = (params) => {
	let token = localStorage.getItem("token");
    params += '&access-token=' + token;
	let req = axios.post(`${getBaseUrl()}/sk2/cc/widgets/v2/share-of-voice`, params, {
		cache: false,
		headers: {
			"Content-Type":
				"application/x-www-form-urlencoded; charset=UTF-8"
		}
	}).then(res => res.data)

	return {
        type: FETCH_OVERALL_SOV_3_DATA,
        payload: req
    };
}

// Get Volume of Conversation Daywise
export const getVolumeOfConversationDaywise = (params) => {
	let token = localStorage.getItem("token");
    params += '&access-token=' + token;
    
    let groupBy = "topic"
    const paramsOptions = params.split("&")
    const groupByoption = paramsOptions.find((p) => p.indexOf("groupBy") > -1);
    if (groupByoption) groupBy = groupByoption.split("=")[1];

	let req = axios.post(`${getBaseUrl()}/volume-of-conversation-subtopics-count-daywise`, params, {
		cache: false,
		headers: {
			"Content-Type":
				"application/x-www-form-urlencoded; charset=UTF-8"
		}
	}).then(res => {
        return { data: res.data, groupBy };
    })

	return {
        type: FETCH_OVERALL_SOV_DATA_DAYWISE,
        payload: req
    };
}

// Get Volume of Conversation Daywise
export const getVolumeOfConversationDaywise2 = (params) => {
	let token = localStorage.getItem("token");
    params += '&access-token=' + token;
    
    let groupBy = "topic"
    const paramsOptions = params.split("&")
    const groupByoption = paramsOptions.find((p) => p.indexOf("groupBy") > -1);
    if (groupByoption) groupBy = groupByoption.split("=")[1];

	let req = axios.post(`${getBaseUrl()}/volume-of-conversation-subtopics-count-daywise`, params, {
		cache: false,
		headers: {
			"Content-Type":
				"application/x-www-form-urlencoded; charset=UTF-8"
		}
	}).then(res => {
        return { data: res.data, groupBy };
    })

	return {
        type: FETCH_OVERALL_SOV_2_DATA_DAYWISE,
        payload: req
    };
}

// Get Volume of Conversation Daywise
export const getVolumeOfConversationDaywise3 = (params) => {
	let token = localStorage.getItem("token");
    params += '&access-token=' + token;
    
    let groupBy = "topic"
    const paramsOptions = params.split("&")
    const groupByoption = paramsOptions.find((p) => p.indexOf("groupBy") > -1);
    if (groupByoption) groupBy = groupByoption.split("=")[1];

	let req = axios.post(`${getBaseUrl()}/volume-of-conversation-subtopics-count-daywise`, params, {
		cache: false,
		headers: {
			"Content-Type":
				"application/x-www-form-urlencoded; charset=UTF-8"
		}
	}).then(res => {
        return { data: res.data, groupBy };
    })

	return {
        type: FETCH_OVERALL_SOV_3_DATA_DAYWISE,
        payload: req
    };
}

export const fetchThemesSOVData = (params) => {
    let token = localStorage.getItem("token");
    let req = axios
        .post(`${getBaseUrl()}/sk2/cc/widgets/v2/themes-sov?access-token=${token}`, params)
        .then(response => {
            return response;
        })
        .catch(err => {
            console.log(err);
            return err;
        });

    return {
        type: FETCH_THEMES_SOV_DATA,
        payload: req
    }
}

export const fetchOverallSentimentData = (params) => {
    let token = localStorage.getItem("token");
    let req = axios
        .post(`${getBaseUrl()}/sk2/cc/widgets/overall-sentiment?access-token=${token}`, params)
        .then(response => {
            return response;
        })
        .catch(err => {
            console.log(err);
            return err;
        });

    return {
        type: FETCH_OVERALL_SENTIMENT_DATA,
        payload: req
    }
}

export const fetchSentimentTrendsData = (params) => {
    let token = localStorage.getItem("token");
    let req = axios
        .post(`${getBaseUrl()}/sk2/cc/widgets/overall-sentiment?access-token=${token}`, params)
        .then(response => {
            return response;
        })
        .catch(err => {
            console.log(err);
        });

    return {
        type: FETCH_SENTIMENT_TRENDS_DATA,
        payload: req
    }
}

export const fetchTopPostsData = (params) => {
    let token = localStorage.getItem("token");
    let req = axios
        .post(`${getBaseUrl()}/sk2/cc/widgets/top-posts?access-token=${token}`, params)
        .then(response => {
            return response;
        })
        .catch(err => {
            console.log(err);
        });

    return {
        type: FETCH_TOP_POSTS_DATA,
        payload: req
    }
}

export const fetchSentimentVerbatimsData = (params) => {
    let token = localStorage.getItem("token");
    let req = axios
        .post(`${getBaseUrl()}/search?access-token=${token}`, params)
        .then(response => {
            return response;
        })
        .catch(err => {
            console.log(err);
        });

    return {
        type: FETCH_SENTIMENT_VERTBATIMS_DATA,
        payload: req
    }
}

export const resetWidgetsData = () => {
    return {
        type: RESET_WIDGETS_DATA
    }
}

export const fetchPlatformBreakData = (params) => {
    let token = localStorage.getItem("token");
    let req = axios
        .post(`${getBaseUrl()}/sk2/cc/widgets/platform-breakdown?access-token=${token}`, params)
        .then(response => {
            return response;
        })
        .catch(err => {
            console.log(err);
            return err;
        });

    return {
        type: FETCH_PLATFORM_BREAK_DATA,
        payload: req
    }
}

export const topicOverviewComparisonSwitcher = (widget) => {
    return {
        type: TOPIC_OVERVIEW_COMPARISON_SWITCHER,
        payload: widget
    }
}

export const switchToComparison = (bool) => {
    return {
        type: SWITCH_TO_COMPARISON,
        payload: bool
    }
}

export const fetchTopicComparisonData = (params) => {
    let token = localStorage.getItem("token");
    let req = axios
        .post(`${getBaseUrl()}/sk2/cc/widgets/campaign-comparison?access-token=${token}`, params)
        .then(response => {
            return response;
        })
        .catch(err => {
            console.log(err);
            return err;
        });

    return {
        type: FETCH_TOPIC_COMPARISON_DATA,
        payload: req
    }
}

export const setTopicComparisonFilters = (params) => {
    return {
        type: SET_TOPIC_COMPARISON_FILTERS,
        payload: params,
    };
}